<template>
  <div :ref="'sig-cell-' + key" class="full-width UDSignatureCell" style="position: relative">
    <div>{{ getTitle(cell) }}</div>
    <canvas
      :id="'sig-canvas-' + key"
      width="10"
      height="10"
      :class="borderOutline"
      @mousedown="onMouseDown"
      @mousemove="onMouseMove"
      @mouseup="onMouseUp"
      @mouseleave="onMouseUp"
      @touchstart="onMouseDown"
      @touchmove="onMouseMove"
      @touchend="onMouseUp"
    >
      Unterschrift funktioniert nicht auf diesem Browser
    </canvas>
    <v-btn class="clear-btn" small icon @click="onClear"><v-icon @click="onClear">mdi-close</v-icon></v-btn>
  </div>
</template>

<script>
import { getTitle } from './wb-common';
import signatureMixin from '../../forms/editors/signatureMixin';

export default {
  props: {
    cell: { type: Object, required: true },
    namespace: { type: String, required: true },
    mIndex: { type: String, default: '' },
  },
  mixins: [signatureMixin],
  data: () => ({
    getTitle,
  }),
  computed: {
    editorModel() {
      return this.$store.state[this.namespace].formInput;
    },
    key() {
      return this.cell.key + this.mIndex;
    },
  },
  watch: {
    cell(v) {
      this.clearPaint();
      this.showSignature();
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid rgba(99, 99, 99, 0.2);
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
  cursor: crosshair;
}
.clear-btn {
  position: absolute;
  right: 0;
  top: 26px;
  width: 36px;
  height: 36px;
}
</style>
